import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLogin } from '../action/Auth';

const PrivateRoute = ({layout: Layout, component: Component, ...rest}) => {
    return (

        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        <Route {...rest} render={props => (
            isLogin() ?
                <Layout>
                    <Component {...props} />
                </Layout>
            :<Redirect to="/" />
        )} />
    );
};

export default PrivateRoute;